import { Image } from "antd";
import { useState } from "react";
import useCancelImage from "../../functions/Image/cancelImage";
import useGetAiImage from "../../functions/Image/getAiImage";
import useUploadImage from "../../functions/Image/uploadImage";
import UploadImageFunc from "./UploadImageFunc";

const timeout_duration = 10;

export default function UploadImageTab(props) {
  const {
    plates,
    setPlates,
    selectedPlateIndex,
    setIsDisableButton,
    activeTabKey,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [loadingTip, setLoadingTip] = useState();

  const { uploadImage, uploadedImageId, setUploadedImageId } = useUploadImage();
  const { getAiImage } = useGetAiImage();
  const { cancelImage } = useCancelImage();

  const getPlates = (cloned_plates) => {
    setPlates(cloned_plates);
    setIsDisableButton((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );
    setUploadedImageId(null);
  };

  const callGetAiImage = (image_id) => {
    getAiImage(
      image_id,
      timeout_duration,
      plates,
      selectedPlateIndex,
      getPlates,
      setIsLoading,
      setLoadingTip
    );
  };

  const rejectImage = () => cancelImage(uploadedImageId, setUploadedImageId);

  function onConfirmImage(capturedImage) {
    if (!uploadedImageId || uploadedImageId == undefined) {
      uploadImage(
        capturedImage,
        timeout_duration,
        setIsLoading,
        setLoadingTip,
        callGetAiImage
      );
    } else {
      callGetAiImage(uploadedImageId);
    }
  }

  return (
    <div className="image-container">
      {plates[selectedPlateIndex]?.ai_image_data == null ? (
        <UploadImageFunc
          content={
            <span>
              Select a photo of the
              <br />
              Mixed Rice plate
            </span>
          }
          shape={"circle"}
          isLoading={isLoading}
          loadingTip={loadingTip}
          onConfirmImage={onConfirmImage}
          onRejectImage={rejectImage}
          activeTabKey={activeTabKey}
        />
      ) : (
        <Image src={plates[selectedPlateIndex]?.ai_image_data} />
      )}
    </div>
  );
}
